<template>
    <div id="catalog">
        <div class="header-wrap">
            <div class="header">
                <span class="left"
                      @click="back"><i class="icon-fanhui"></i></span>
                <em>作业预览</em>
            </div>
        </div>
        <template v-if="loading">
            <div class="content">
                <noResouse v-if="!question.length"></noResouse>
                <div class="list-wrap"
                     v-else>
                    <dl class="list">
                        <dd v-for="item in question"
                            @click="open(item.video_url)">
                            <span class="icon-play"></span>
                            <p>{{item.name}}</p>
                        </dd>
                    </dl>
                </div>
            </div>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
        <videoPlayer v-if="!inApp"
                     ref="videoPlayer"
                     @closePlayer="closePlayer"
                     v-show="playFlag"
                     :video_url="video_url"
                     submit="1"></videoPlayer>
    </div>
</template>
<script type="text/ecmascript-6">
import videoPlayer from 'SRC/components/base/videoPlayer.vue';  // 视频播放弹窗
import noResouse from 'COMPONENTS/noResouse.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';
export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            taskId: this.$route.params.taskid,
            question: [],
            loading: false,
            video_url: '',
            playFlag: false
        }
    },
    created () {
        this.$http.get(API_URL_TASK_API + '/szyz/check/task/preview?message_id=' + this.taskId).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.question = this.question.concat(res.data);
            }
            this.$nextTick(() => {
                this.loading = true;
            })
        })
    },
    methods: {
        back () {
            this.$router.go(-1)
        },
        open (arg) {
            if (this.inApp) {
                this.appFunction("ys_video", `${arg},1`);
            } else {
                this.video_url = arg;
                this.playFlag = true;
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                })
            }
        },

        /**退出视频 */
        closePlayer () {
            this.playFlag = false;
        },
    },
    components: {
        noResouse, loadingS, videoPlayer
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#catalog {
    min-height: 100vh;
    .header {
        background: #5e89ef;
        .left {
            display: block;
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/choose_back.png") 0 0 no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 0.6rem;
            top: 50%;
            -webkit-transform: translate(0, -50%);
            -ms-transform: translate(0, -50%);
            transform: translate(0, -50%);
            font-size: 1.2rem;
        }
    }
    .content {
        .prompting {
            position: relative;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 28px / $ppr;
            color: #5e89ef;
            text-align: center;
            background-color: #fff;
            i {
                display: block;
                position: absolute;
                top: 0;
                right: 40px / $ppr;
                &:before {
                    color: #ccc;
                    content: "X";
                }
            }
        }

        .list-wrap {
            .list {
                background-color: #fff;
                dt {
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    font-weight: 600;
                }
                dd {
                    position: relative;
                    padding-left: 24px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;

                    color: #333;
                    border-top: 1px / $ppr solid #e8e8e8;
                    display: flex;
                    display: -webkit-flex;
                    align-items: center;
                    -webkit-align-items: center;
                    .icon-play {
                        width: 40px / $ppr;
                        height: 40px / $ppr;
                        background-image: url(img/icon_video.png);
                        background-size: contain;
                    }
                    p {
                        font-size: 30px / $ppr;
                        color: #555;
                        padding-left: 24px / $ppr;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        flex: 1;
                        -webkit-flex: 1;
                    }
                }
            }
        }
    }
}
</style>
